import type { LayerModel, Selection, SelectionLevel } from '../core/types';

export function selectionForFragment(model: LayerModel | null, fragmentId: string, level: SelectionLevel): Selection {
  const fragment = model?.fragmentsById.get(fragmentId);
  if (!fragment) return null;
  if (level === 'finca') return { kind: 'finca', id: fragment.fincaId };
  if (level === 'fragment') return { kind: 'fragment', id: fragment.id };
  if (level === 'tablon') return { kind: 'tablon', id: fragment.tablonId };
  return { kind: 'suerte', id: fragment.suerteId };
}

export function selectedFragmentIds(model: LayerModel | null, selection: Selection): ReadonlySet<string> {
  if (!model || !selection) return new Set();
  if (selection.kind === 'fragment') return new Set([selection.id]);
  const entity = selection.kind === 'finca'
    ? model.fincas.get(selection.id)
    : selection.kind === 'suerte'
      ? model.suertes.get(selection.id)
      : model.tablones.get(selection.id);
  return new Set(entity?.fragmentIds ?? []);
}
